module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av10-351996446799c51e66733e50d330dce3.jpg";